import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=5c760cbe&scoped=true"
import script from "./projectOverview.vue?vue&type=script&lang=js"
export * from "./projectOverview.vue?vue&type=script&lang=js"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=5c760cbe&prod&lang=scss&scoped=true"
import style1 from "./projectOverview.vue?vue&type=style&index=1&id=5c760cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c760cbe",
  null
  
)

export default component.exports